import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicLandingPage() {
  const { slug } = useParams();
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/launch-page/live/${slug}`)
      .then(r => {
        if (!r.ok) throw new Error('Not found');
        return r.text();
      })
      .then(setHtml)
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div style={{ background: '#080808', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" }}>
        <div style={{ textAlign: 'center', color: '#f5f0e8' }}>
          <h1 style={{ fontSize: '48px', marginBottom: '8px' }}>404</h1>
          <p style={{ color: 'rgba(245,240,232,0.4)' }}>This page doesn't exist or has been unpublished.</p>
        </div>
      </div>
    );
  }

  if (!html) {
    return (
      <div style={{ background: '#080808', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: 'rgba(245,240,232,0.3)', fontSize: '14px' }}>Loading...</div>
      </div>
    );
  }

  return <iframe srcDoc={html} title="Published Landing Page" style={{ width: '100%', height: '100vh', border: 'none' }} />;
}
